//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Positioning.js";
import "../no/TaggedObject.js";
import "../no/PartLoadStatus.js";
let d=[[[0,"Context",1,0],[0,"LoadReferencedGeometry",1,0],[0,"LoadStatus",0,"PartLoadStatus",0],[0,"NumberOfConvertedParts",0,0]],[[[],"ConvertMatingConditions",{},0,0],[["n_converted_constraints"],"GetConvertedConstraints",{R_:{converted_constraints:"Positioning.Constraint[]"}},0,0],[["n_converted_constraints"],"GetConvertedParts",{R_:{converted_constraints:"Positioning.Constraint[]"}},0,0],[["show_all_results","n_result_lines"],"GetLatestResults",{R_:{result_lines:""}},1,0],[["show_all_results","n_result_lines"],"GetResults",{R_:{result_lines:""}},1,0],[[],"DeleteResults",{},0,0],[[],"Destroy",{},0,0]],[]];
SPLM.Positioning.MatingConverter = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Positioning.MatingConverter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Positioning.MatingConverter.PartContext = Object.freeze({
    "InOwningPart" : "InOwningPart", "InLoadedChildren" : "InLoadedChildren", "InAllChildren" : "InAllChildren"});

export default SPLM;